import Icon from "@material-ui/icons/RecentActors";
import PersonInChargeList from "./PersonInChargeList";
import PersonInChargeCreate from "./PersonInChargeCreate";
import PersonInChargeEdit from "./PersonInChargeEdit";
import PersonInChargeShow from "./PersonInChargeShow";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "personInCharges",
  create: PersonInChargeCreate,
  list: PersonInChargeList,
  show: PersonInChargeShow,
  edit: PersonInChargeEdit,
  icon: Icon,
};
